module.exports = __webpack_public_path__ + "media/icons/standard-520f8d6d.png";